<template>
  <div class="login">
    <loading :active.sync="is_loading"></loading>
    <b-modal id="register-modal" title="REGISTRO" scrollable>
      <b-container fluid>
        <b-form @reset="onReset">
          <b-form-group>
            Crea tu cuenta ahora mismo, ¡solo te tomará 1 minuto!
          </b-form-group>
          <b-form-group id="name-group" label="Nombre(s)" label-for="name">
            <b-form-input
              :state="nameState"
              id="name"
              v-model="user.name"
              type="text"
              required
              aria-describedby="input-live-help input-live-feedback"
            ></b-form-input>

            <b-form-text id="input-live-help"
              >Ingresa tu nombre sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="lastname-group"
            label="Apellido Paterno"
            label-for="lastname"
          >
            <b-form-input
              id="lastname"
              :state="nameState2"
              v-model="user.lastname"
              type="text"
              required
              aria-describedby="input-live-help-2 input-live-feedback-2"
            ></b-form-input>

            <b-form-text id="input-live-help-2"
              >Ingresa tu apellido sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="surname-group"
            label="Apellido Materno"
            label-for="surname"
          >
            <b-form-input
              id="surname"
              :state="nameState3"
              v-model="user.surname"
              type="text"
              required
              aria-describedby="input-live-help-3"
            ></b-form-input>
            <b-form-text id="input-live-help-3"
              >Ingresa tu apellido sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group id="gender-group" label="Género" label-for="gender">
            <b-form-select
              :state="genderValidate"
              v-model="user.gender"
              :options="options"
              aria-describedby="input-live-help-4"
            ></b-form-select>
            <b-form-text id="input-live-help-4">Elige una opción</b-form-text>
          </b-form-group>
          <b-form-group id="phone-group" label="Teléfono" label-for="phone">
            <b-form-input
              id="phone"
              :state="phoneValidate"
              v-model="user.phone"
              type="tel"
              required
              aria-describedby="input-live-help-5"
            ></b-form-input>
            <b-form-text id="input-live-help-5"
              >Ingresa un numero de 10 digitos</b-form-text
            >
          </b-form-group>
          <b-form-group id="email-group" label="E-mail" label-for="email">
            <b-form-input
              @click.right.prevent
              @copy.prevent
              @paste.prevent
              id="email"
              v-model="user.email"
              :state="emailValidate"
              type="email"
              required
              aria-describedby="input-live-help-6"
            ></b-form-input>
            <b-form-text id="input-live-help-6"
              >Ingresa un correo válido</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="email-group"
            label="Confirmación de E-mail"
            label-for="emailValidate"
          >
            <b-form-input
              @click.right.prevent
              @copy.prevent
              @paste.prevent
              id="emailValidate"
              v-model="user.emailConfirmacion"
              :state="emailValidate2"
              type="email"
              required
              aria-describedby="input-live-help-7"
            ></b-form-input>
            <b-form-text id="input-live-help-7"
              >Ingresa el mismo correo válido</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="password-group"
            label="Contraseña"
            label-for="password"
          >
            <b-form-input
              id="password"
              :state="passwordValidate"
              v-model="user.password"
              type="password"
              aria-describedby="input-live-help-8"
              required
            ></b-form-input>
            <b-form-text id="input-live-help-8">Mínimo 6 dígitos</b-form-text>
          </b-form-group>
          <b-form-group
            id="password-group"
            label="Verificar contraseña"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="user.password_confirmation"
              :state="passwordValidate2"
              type="password"
              required
              aria-describedby="input-live-help-9"
            ></b-form-input>
            <b-form-text id="input-live-help-9">Mínimo 6 dígitos</b-form-text>
          </b-form-group>
          <b-form-group class="text-center">
            <!-- listen to verify event emited by the recaptcha component -->
            <recaptcha ref="recaptcha" @verify="submit"></recaptcha>
            <b-button
            @click="executerecaptcha()"
              :disabled="block_button"
              class="btn text-light"
              type="button"
              style="
                background: #0f182b;
                font-weight: bold;
                width: 175px;
                height: 40px;
              "
            >
              REGISTRARME
            </b-button>
          </b-form-group>
        </b-form>
      </b-container>
      <template v-slot:modal-footer>
        <div class="w-100 text-center text-light">
          Obvio ya tengo mi cuenta, quiero
          <b-link
            @click="$bvModal.hide('register-modal')"
            class="text-light"
            style="font-weight: bold"
            >iniciar sesión.</b-link
          >
        </div>
      </template>
    </b-modal>

    <!--b-modal id="register-modal" title="¡Registrate en esta gran familia!" v-if="show" hide-footer>
			<b-form @submit="onSubmit" @reset="onReset" >
				<b-form-group>
				Crea tu cuenta ahora mismo, ¡solo tomas 1 minuto!
				</b-form-group>
				<b-form-group id="name-group" label="Nombre(s)" label-for="name">
					<b-form-input id="name" v-model="user.name" type="text" required ></b-form-input>
				</b-form-group>
				<b-form-group id="lastname-group" label="Apellido Paterno" label-for="lastname">
					<b-form-input id="lastname" v-model="user.lastname" type="text" required ></b-form-input>
				</b-form-group>
				<b-form-group id="surname-group" label="Apellido Materno" label-for="surname">
					<b-form-input id="surname" v-model="user.surname" type="text" required ></b-form-input>
				</b-form-group>
				<b-form-group id="phone-group" label="Telefono" label-for="phone">
					<b-form-input id="phone" v-model="user.phone" type="tel" required ></b-form-input>
				</b-form-group>
				<b-form-group id="email-group" label="Correo electrónico" label-for="email">
					<b-form-input id="email" v-model="user.email" type="email" required ></b-form-input>
				</b-form-group>
				<b-form-group id="password-group" label="Contraseña" label-for="password">
					<b-form-input id="password" v-model="user.password" type="password" required></b-form-input>
				</b-form-group>
				<b-form-group id="password-group" label="Confirmar contraseña" label-for="password">
					<b-form-input id="password" v-model="user.password" type="password" required></b-form-input>
				</b-form-group>
				<b-button class="btn btn-block btn-outline-primary" type="submit">
					Registrar
				</b-button>
				<br>
				<b-form-group>
				Si ya tienes tu cuenta, ¿que esperas?  <b-link @click="close()">¡Inicia sesión ahora!</b-link>
				</b-form-group>
			</b-form>
		</b-modal-->
    <!-- #login-modal -->
  </div>
</template>

<script>
const axios = require("axios");
import Loading from "vue-loading-overlay";
import recaptcha from "../components/Recaptcha";

export default {
  name: "RegisterForm",
  components: {
    Loading,
    recaptcha,
  },
  data() {
    return {
      tokenRecaptcha:null,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      user: {
        name: "",
        lastname: "",
        surname: "",
        email: "",
        emailConfirmacion: "",
        phone: "",
        password: "",
        password_confirmation: "",
        gender: "",
      },
      options: [
        { value: null, text: "Selecciona una opción", disabled: true },
        { value: 1, text: "Mujer" },
        { value: 2, text: "Hombre" },
        { value: 3, text: "No binario" },
      ],
      show: true,
      letters: /^[ a-zA-Z]{1,}$/,
      phone: /^\d{10}$/,
      email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
      password: /^.{6,20}$/,
      block_button: false,
      is_loading: false,
    };
  },
  computed: {
    nameState() {
      return this.letters.test(this.user.name) ? true : false;
    },
    nameState2() {
      return this.letters.test(this.user.lastname) ? true : false;
    },
    nameState3() {
      return this.letters.test(this.user.surname) ? true : false;
    },
    phoneValidate() {
      return this.phone.test(this.user.phone) ? true : false;
    },
    emailValidate() {
      return this.email.test(this.user.email) ? true : false;
    },
    emailValidate2() {
      return this.email.test(this.user.emailConfirmacion) &&
        this.user.emailConfirmacion === this.user.email
        ? true
        : false;
    },
    passwordValidate() {
      return this.password.test(this.user.password) ? true : false;
    },
    passwordValidate2() {
      return this.password.test(this.user.password_confirmation) &&
        this.user.password_confirmation === this.user.password
        ? true
        : false;
    },
    genderValidate() {
      if (this.user.gender === "" || this.user.gender === null) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    // send your recaptcha token to the server to verify it
    submit(response) {
      this.tokenRecaptcha = response;
      this.sendData();
      // console.log("token de recaptcha: ", response);
    },
    // execute the recaptcha widget
    executerecaptcha() {
      this.$refs.recaptcha.execute();
    },
    hideModal() {
      this.$refs["register-modal"].hide();
    },
    sendData: function () {
      this.is_loading = true;
      this.block_button = true;
      if ($cookies.isKey("ctoken")) {
        axios({
          method: "POST",
          url: this.api_url + "/subscribers",
          data: {
            name: this.user.name,
            lastname: this.user.lastname,
            surname: this.user.surname,
            phone: this.user.phone,
            email: this.user.email,
            password: this.user.password,
            gender: this.user.gender,
            token: this.tokenRecaptcha,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            this.is_loading = false;
            this.block_button = false;
            var today = new Date();
            console.log(response);
            console.info("Se obtuvo el token del usuario");
            if (response.data.is_logged) {
              this.$snotify.success(response.data.response);
              this.show = false;
              //$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7, '/', null, true, 'Lax');
              $cookies.set(
                "utoken",
                response.data.token,
                today.getTime() + 3600000 * 24 * 7
              );
              $cookies.set(
                "uidmmkg",
                response.data.user.id,
                today.getTime() + 3600000 * 24 * 7
              );
              this.$router.go();
            } else {
              this.$snotify.warning(response.data.message);
            }
          })
          .catch((error) => {
            this.is_loading = false;
            this.block_button = false;
            console.error(error);
          });
      } else {
        this.$snotify.info("No se ha podido registrar al usuario. -- Err 002");
      }
    },
    onReset: function (evt) {
      evt.preventDefault();
      console.info("Reseteando");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
